import Script from 'next/script'
import { FC, useEffect } from 'react'
import { InstagramWrapper } from './Instagram.styled'

interface Props {
  url?: string
}

/**
 * Normalise Instagram URLs for embedding:
 * 1. Convert '/reels/' → '/reel/' because Instagram's embed.js
 *    only recognizes the canonical '/reel/' path (plural '/reels/' won't render).
 * 2. Remove any trailing slash to avoid double-slash issues
 *    when constructing the embed permalink.
 */
const normaliseUrl = (url?: string) => {
  if (!url) return ''
  return url.replace('/reels/', '/reel/').replace(/\/$/, '')
}

const Instagram: FC<Props> = ({ url }) => {
  const normalisedUrl = normaliseUrl(url)

  // Ensure Instagram embed.js processes all blockquotes
  useEffect(() => {
    if ((window as any).instgrm?.Embeds) {
      ;(window as any).instgrm.Embeds.process()
    }
  }, [normalisedUrl])

  if (!url) return null

  return (
    <>
      <Script async defer src="https://www.instagram.com/embed.js" />

      <InstagramWrapper>
        <blockquote
          className="instagram-media"
          data-instgrm-captioned
          data-instgrm-permalink={`${normalisedUrl}/?utm_source=ig_embed&amp;utm_campaign=loading`}
          data-instgrm-version="14"
          style={{ minWidth: '100%' }}
        >
          <a
            href={`${normalisedUrl}/?utm_source=ig_embed&amp;utm_campaign=loading`}
            target="_blank"
            rel="noreferrer"
          />
        </blockquote>
      </InstagramWrapper>
    </>
  )
}

export default Instagram
